import BaseClients from '@components/features/landing-pages/BaseClients';
import Highlight from '@components/features/Highlight';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';

const Clients = () => {
  const renderHeader = () => (
    <Highlight
      text="Not your typical Brokerage [+]"
      queries={[
        {
          key: 'Brokerage [+]',
          description:
            'A brokerage is a company that represents multiple insurance companies and helps you evaluate and choose a plan.',
        },
      ]}
      renderText={(text) => (
        <Header as="h2" lineHeight="180%">
          {text}
        </Header>
      )}
    />
  );

  const renderDescription = () => (
    <Highlight
      text="Traditional Medicare brokers operate by getting you on the plan that gives them the highest commission [+] from insurance companies. Here, we’re obsessed with matching our clients to the right plan. We’ll recommend a plan even if it pays us nothing."
      queries={[
        {
          key: 'commission [+]',
          description:
            'Insurance companies traditionally pay brokerages a commission for signing people up on their plans. At Fair Square, our recommendations are not influenced by that commission.',
        },
      ]}
      renderText={(text) => <Body1>{text}</Body1>}
    />
  );

  return <BaseClients renderHeader={renderHeader} renderDescription={renderDescription} />;
};

export default Clients;
